import request from '@/utils/request'

export function getCodeSign (data) {
  return request({
    url: '/wechat/card/getCodeSign',
    method: 'post',
    data: data
  })
}

export function sendCode (data) {
  return request({
    url: '/wechat/card/sendCode',
    method: 'post',
    data: data
  })
}

export function fetchClientList (query) {
  return request({
    url: '/card/api/client/index',
    method: 'get',
    params: query
  })
}

export function fetchClient (id) {
  return request({
    url: '/card/api/client/view',
    method: 'get',
    params: { id }
  })
}

export function createClient (data) {
  return request({
    url: '/card/api/client/insert',
    method: 'post',
    data
  })
}

export function updateClient (data) {
  return request({
    url: '/card/api/client/update',
    method: 'post',
    data
  })
}

export function deleteClient (id) {
  return request({
    url: '/card/api/client/delete',
    method: 'post',
    params: { id }
  })
}

export function clientRecharge (id, amount, mobile, code) {
  return request({
    url: '/card/api/client/recharge',
    method: 'post',
    params: { client_id: id, amount: amount, mobile: mobile, code: code }
  })
}

export function clientQuota (id, amount) {
  return request({
    url: '/card/api/client/quota',
    method: 'post',
    params: { client_id: id, amount: amount }
  })
}

export function fetchClientInfo (id) {
  return request({
    url: '/card/api/client/info',
    method: 'get',
    params: { id }
  })
}

export function updateNoticeConfig (data) {
  return request({
    url: '/card/api/client/updateNoticeConfig',
    method: 'post',
    data
  })
}

export function activeClientRecharge (data) {
  return request({
    url: '/card/api/client/clientRecharge',
    method: 'post',
    data
  })
}

export function orderStatus (data) {
  return request({
    url: '/card/api/client/getOrderStatus',
    method: 'post',
    data
  })
}

export function enable (data) {
  return request({
    url: '/card/api/client/enable',
    method: 'post',
    params: data
  })
}

// eslint-disable-next-line camelcase
export function clientMonitor (client_id) {
  return request({
    url: '/card/api/client/clientMonitor',
    method: 'post',
    params: {client_id}
  })
}



// WEBPACK FOOTER //
// ./src/card/api/client.js